import React, { FC, memo } from 'react';

import usePrefix from 'utils/usePrefix';
import { TABS, CategoryKey } from 'components/ResqlExpert/constants';

import {
  TabBarStyled,
  TabItemStyled,
  TabBodyStyled,
  SubmissionFormContentStyled,
} from './styles';

interface Props {
  activeTab: CategoryKey;
  setActiveTab: (key: CategoryKey) => void;
  tabMap: Record<CategoryKey, React.ReactNode>;
}

const SubmissionFormContent: FC<Props> = ({ activeTab, setActiveTab, tabMap }) => {
  const t = usePrefix('ResqlExpert');

  return (
    <SubmissionFormContentStyled>
      <TabBarStyled role="tablist">
        {TABS.map((key) => (
          <TabItemStyled
            type="button"
            role="tab"
            key={key}
            id={`tab-${key}`}
            active={activeTab === key}
            aria-selected={activeTab === key}
            aria-controls={`tabpanel-${key}`}
            onClick={() => setActiveTab(key)}
          >
            {t(key)}
          </TabItemStyled>
        ))}
      </TabBarStyled>
      <TabBodyStyled>
        {TABS.map((key) => (
          <div
            key={key}
            id={`tabpanel-${key}`}
            role="tabpanel"
            aria-labelledby={`tab-${key}`}
            hidden={activeTab !== key}
          >
            {tabMap[key]}
          </div>
        ))}
      </TabBodyStyled>
    </SubmissionFormContentStyled>
  );
};

export default memo(SubmissionFormContent);
